import { render, staticRenderFns } from "./HomeContainerCardsText.vue?vue&type=template&id=ff7d2486&scoped=true"
import script from "./HomeContainerCardsText.vue?vue&type=script&lang=js"
export * from "./HomeContainerCardsText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7d2486",
  null
  
)

export default component.exports